import { render, staticRenderFns } from "./ShareDraw.vue?vue&type=template&id=74c81dbe&scoped=true"
import script from "./ShareDraw.vue?vue&type=script&lang=js"
export * from "./ShareDraw.vue?vue&type=script&lang=js"
import style0 from "./ShareDraw.vue?vue&type=style&index=0&id=74c81dbe&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c81dbe",
  null
  
)

export default component.exports